import { createFileRoute, redirect } from '@tanstack/react-router';

/** The store's settings hub lives on the store page under the organisation. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/org/stores/$storeId',
      params: { storeId: params.storeId },
      search: { tab: 'settings' },
    });
  },
});
